import React, { useEffect } from "react";

//components
import TextField from "@mui/material/TextField";
import { Modal } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import { DatePicker } from "@mui/lab";
import { styled } from "@mui/material/styles";

//constants
import { IBasicDateModalProps } from "./module/constants";
import messages from "./module/messages";

//utils
import enLocale from "date-fns/locale/en-GB";

//styles
import classes from "./BasicDateModal.module.scss";

const BasicDateModal = (props: IBasicDateModalProps) => {
  const [value, setValue] = React.useState<Date | null>(null);
  const { show, onCloseModal, onConfirm, selectedRow, selectedRowItem } = props;

  useEffect(() => {
    if (selectedRowItem && selectedRowItem.end_date) {
      const dateToSplit = selectedRowItem.end_date.split(",")[0].split("/");
      const day = dateToSplit[1];
      const month = dateToSplit[0];
      const year = dateToSplit[2];
      const endDate = new Date(`${day} ${month} ${year}`);
      setValue(endDate);
    }
    return () => {
      setValue(null);
    };
  }, [selectedRowItem]);

  return (
    <>
      <Modal show={show} size="lg" centered contentClassName={classes.content}>
        <Modal.Header className={classes.header}>
          <Modal.Title style={{ fontSize: "1rem" }}>
            <FormattedMessage {...messages.title} />
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ fontSize: "0.75rem" }}>
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 d-flex justify-content-center flex-wrap">
              <LocalizationProvider
                dateAdapter={AdapterDateFns}
                locale={enLocale}
              >
                <DatePicker
                  label={<FormattedMessage {...messages.date} />}
                  value={value}
                  onChange={(newValue) => {
                    setValue(newValue);
                  }}
                  renderInput={(params) => (
                    <CssTextField
                      className={classes["prova"]}
                      variant="filled"
                      {...params}
                    />
                  )}
                />
              </LocalizationProvider>
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer className={classes.footer}>
          <button
            className={`${classes.btn} ${classes["btn-cancel"]}`}
            onClick={onCloseModal}
          >
            <FormattedMessage {...messages.cancel} />
          </button>
          <button
            className={`${classes.btn} ${classes["btn-confirm"]}`}
            onClick={() => onConfirm(selectedRow, value)}
          >
            <FormattedMessage {...messages.confirm} />
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default BasicDateModal;

const CssTextField = styled(TextField)({
  "& .MuiFilledInput-root": {
    height: "2rem ",
    fontSize: "12px",
    "& fieldset": {
      height: "2rem",
      top: "-8px",
    },
    "&:hover fieldset": {},
    "&.Mui-focused fieldset": {},
  },
  "& .MuiFilledInput-input": {
    height: "2rem ",
    fontSize: "12px",
    paddingTop: "10px",
  },
  "& label.Mui-focused": {},
  "& .MuiInput-underline:after": {},
  "& .MuiInputLabel-root": {
    height: "2rem",
    fontSize: "10px",
    top: "-8px",
  },
});
